import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import { useTheme } from '@mui/material/styles';
import { ColorModeContext } from 'common/contexts/ColorModeContext';

export function ThemeSwitch() {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';
    const accentColor = isDark ? theme.palette.primary.accent : theme.palette.primary.light;

    return (
        <ColorModeContext.Consumer>
            {({ toggleColorMode, currentMode }) => {
                const isChecked = currentMode === 'dark';

                return (
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            alignItems: 'center',
                            justifyContent: 'center',
                            p: 1,
                            position: 'absolute',
                            bottom: 6,
                        }}
                    >
                        <LightModeIcon sx={{ fontSize: 16, color: !isChecked ? accentColor : 'rgba(255,255,255,0.4)' }} />
                        <ButtonBase
                            onClick={toggleColorMode}
                            disableRipple
                            style={{
                                margin: '0 4px',
                                width: 24,
                                height: 14,
                                borderRadius: 7,
                                backgroundColor: isChecked ? accentColor : 'rgba(255,255,255,0.3)',
                                position: 'relative',
                                transition: 'background-color 0.2s',
                            }}
                        >
                            <div
                                style={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    backgroundColor: '#fff',
                                    position: 'absolute',
                                    top: 3,
                                    left: isChecked ? 13 : 3,
                                    transition: 'left 0.2s',
                                }}
                            />
                        </ButtonBase>
                        <DarkModeIcon sx={{ fontSize: 16, color: isChecked ? accentColor : 'rgba(255,255,255,0.4)' }} />
                    </Box>
                );
            }}
        </ColorModeContext.Consumer>
    );
}
